import { render } from "./BorrowRates.vue?vue&type=template&id=06376ebe"
import script from "./BorrowRates.vue?vue&type=script&lang=js"
export * from "./BorrowRates.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/defi/BorrowRates.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06376ebe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06376ebe', __exports__)) {
    api.reload('06376ebe', __exports__)
  }
  
  module.hot.accept("./BorrowRates.vue?vue&type=template&id=06376ebe", () => {
    api.rerender('06376ebe', render)
  })

}


export default __exports__